import {Breadcrumbs as MuiBreadcrumbs, Link, Typography, Box} from "@mui/material"
import {NavigateNext as NavigateNextIcon} from "@mui/icons-material"
import {useNavigate} from "react-router-dom"
import {useRef, useState, useEffect} from "react"
import {useTranslation} from "react-i18next"
import {colors} from "@indebted/theme/colors"

import {useCustomerInfo} from "../../src/useCustomerInfo"

type BreadcrumbItem = {
	label: string
	href: string
}

const getMaxItems = (containerWidth: number) => {
	if (containerWidth <= 430) {
		return 2
	} else if (containerWidth <= 500) {
		return 3
	}
	return 4
}

export function Breadcrumbs({currentStep, items = []}: {currentStep: string; items?: BreadcrumbItem[]}) {
	const {t} = useTranslation()
	const navigate = useNavigate()
	const containerRef = useRef<HTMLDivElement>(null)
	const [maxItems, setMaxItems] = useState<number>(4)

	const customerInfo = useCustomerInfo()

	useEffect(() => {
		const handleResize = () => {
			if (containerRef.current) setMaxItems(getMaxItems(containerRef.current.offsetWidth))
		}

		window.addEventListener("resize", handleResize)
		return () => window.removeEventListener("resize", handleResize)
	}, [])

	if (customerInfo.isLoading || customerInfo.isError) {
		return null
	}

	const secureCode = customerInfo.customerInfo?.SecureCode

	return (
		<Box ref={containerRef} sx={{width: "100%"}}>
			<MuiBreadcrumbs
				aria-label="breadcrumb"
				separator={<NavigateNextIcon fontSize="small" />}
				itemsAfterCollapse={Math.max(maxItems - 1, 1)}
				maxItems={maxItems}
				sx={{margin: "0px"}}
			>
				<Link
					underline="hover"
					color="inherit"
					onClick={() => navigate(`/${secureCode}`)}
					sx={{
						color: "#5B5FED",
						fontSize: "0.9375rem",
						fontWeight: "500",
						lineHeight: "1rem",
						cursor: "pointer",
						"&:hover": {
							textDecoration: "underline",
						},
					}}
				>
					{t("breadcrumbs.home")}
				</Link>
				{items?.map((item, index) => (
					<Link
						key={index}
						underline="hover"
						color="inherit"
						onClick={() => navigate(item.href)}
						sx={{
							color: "#5B5FED",
							fontSize: "0.9375rem",
							fontWeight: "500",
							lineHeight: "1rem",
							cursor: "pointer",
							"&:hover": {
								textDecoration: "underline",
							},
						}}
					>
						{item.label}
					</Link>
				))}
				<Typography
					variant="body1"
					sx={{
						color: colors.gray[500],
						fontSize: "0.9375rem",
						fontWeight: "500",
						lineHeight: "1rem",
					}}
				>
					{currentStep}
				</Typography>
			</MuiBreadcrumbs>
		</Box>
	)
}
